import React, { useEffect } from 'react';

const ConceptViewer = ({ loId }) => {
    if (!loId) {
        return <p style={{ fontStyle: 'italic', color: 'gray' }}>No document selected.</p>;
    }

    const fileUrl = `https://www.eduhax.com/Concept/${loId}.docx`;
    const encodedUrl = encodeURIComponent(fileUrl);
    const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;

    useEffect(() => {
        console.log('📂 ConceptViewer mounted');
        console.log('🔗 Original file URL:', fileUrl);
        console.log('🧼 Encoded file URL:', encodedUrl);
        console.log('📥 Viewer iframe URL:', viewerUrl);
    }, [fileUrl]);

    return (
        <div>
            <iframe
                title="Microsoft Word Viewer"
                src={viewerUrl}
                width="100%"
                height="600"
                style={{ border: '1px solid #ccc', borderRadius: '8px' }}
            />
        </div>
    );
};

export default ConceptViewer;
